<template>
  <div>
    <ContactUsThanksHero header="CONTACT US"
                         paragraph="Thank you for your request. A member of our sun safety squad will be getting back to you soon. Pending"
                         image="super-hero-4.gif"/>
  </div>
</template>
<script>
import ContactUsThanksHero from '../thanks/ContactUsThanksHero.vue'

export default {
  components: {
    ContactUsThanksHero,
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";
</style>
